import { useFrame } from './useFrame';
import { useGame } from './useGame';
export function useWatch(component, onChange) {
    var game = useGame();
    useFrame(function () {
        if (game.componentManager.wasChangedLastFrame(component.id)) {
            onChange(component);
        }
    });
}
//# sourceMappingURL=useWatch.js.map